const moment = require('moment-timezone');
//Trading period methods
const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];

const monthNamesShort = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
  'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

const preArr = ['Q1', 'Q2', 'Q3', 'Q4'];

const initialYear = 2016;

// only vanilla js in this file!
function getYearsRange() {
  var currentYear = (new Date()).getFullYear(),
    years = [];
  for (var i = currentYear; i >= initialYear; i--) {
    years.push(i);
  }
  return years;
}

function getTradingPeriodPreIndex(tradingPeriod) {
  if (tradingPeriod.indexOf('Q') == -1) return '';
  var split = tradingPeriod.split(' ');
  return split[0];
}

function getPeriodEnd(year, month) {
  if (month == 12) {
    month = 0;
    year++;
  }
  return new Date(year, month, 1);
}
function getPeriodBegin(year, month) {
  month--;
  return new Date(year, month, 1);
}

function getPeriodsForQuarter(qNumber, year) {
  const begin = 3 * (qNumber - 1);
  const end = 3 * qNumber;

  return monthNames.slice(begin, end).map(function (month) { // only vanilla js in this file
    return month + ' ' + year;

  });
}

function getTradingPeriodMonthIndex(tradingPeriod) {
  var split = tradingPeriod.split(' ');
  var pre = getTradingPeriodPreIndex(tradingPeriod);
  if (pre.toUpperCase().indexOf('Q') == 0) {
    return '';
  } else {
    var fullMonth = moment(split[0], 'MMM').format('MMMM');
    var monthIndex = monthNames.indexOf(fullMonth);
    if (monthIndex == -1) return '';
    return monthIndex;
  }
}

function getTradingPeriodYearIndex(tradingPeriod) {
  var split = tradingPeriod.split(' ');
  var fullYear = '20' + split[1];
  if (isNaN(Number(fullYear))) return '';
  return fullYear; // Fully qualified year
}

function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}


//variant without moment.js use
function getTradingPeriodBegin(tradingPeriodPrefix, tradingPeriod, is_custom_timeframe) {
  if (is_custom_timeframe === true || tradingPeriodPrefix == 'PROMPT' || tradingPeriodPrefix == 'LOADED') return null;
  var day = 1;
  var pre = getTradingPeriodPreIndex(tradingPeriod);

  var month = getTradingPeriodMonthIndex(tradingPeriod);
  var year = getTradingPeriodYearIndex(tradingPeriod);  

  if (pre.toUpperCase().indexOf('Q1') !== -1) {
    month = 0; // January
  }
  if (pre.toUpperCase().indexOf('Q2') !== -1) {
    month = 3;// April
  }
  if (pre.toUpperCase().indexOf('Q3') !== -1) {
    month = 6;// July
  }
  if (pre.toUpperCase().indexOf('Q4') !== -1) {
    month = 9;// October
  }

  if (month === '' || year === '') return null;

  // Date.UTC(year, month, day) generates number of miliseconds by UTC based on parsed data
  // new Date() from utc milisecond creates needed date object with utc timezone
  const begin = new Date(Date.UTC(year, month, day));

  return begin;
}


function getTradingPeriodBeginV2(tradingPeriodPrefix, tradingPeriod, is_custom_timeframe) {
  if (is_custom_timeframe === true || tradingPeriodPrefix == 'PROMPT' || tradingPeriodPrefix == 'LOADED') return null;
  var day = 1;

  var dateObj = { day: 1 };
  var pre = getTradingPeriodPreIndex(tradingPeriod);

  var month = getTradingPeriodMonthIndex(tradingPeriod);
  var year = getTradingPeriodYearIndex(tradingPeriod);
  
  if (pre.toUpperCase().indexOf('Q1') !== -1) {
    month = 0; // January
  }
  if (pre.toUpperCase().indexOf('Q2') !== -1) {
    month = 3;// April
  }
  if (pre.toUpperCase().indexOf('Q3') !== -1) {
    month = 6;// July
  }
  if (pre.toUpperCase().indexOf('Q4') !== -1) {
    month = 9;// October
  }

  if (month === '' || year === '') return null;

  dateObj.month = month;
  dateObj.year = year;

  // don't use "London/Europe" or other utc timezone, it generates DST problem
  const begin = moment.tz(dateObj, 'UTC');
  console.log(begin.format());
  return begin;
}

//variant without moment.js use
function getTradingPeriodEnd(tradingPeriodPrefix, tradingPeriod, is_custom_timeframe) {
  if (is_custom_timeframe === true || tradingPeriodPrefix == 'PROMPT' || tradingPeriodPrefix == 'LOADED') return null;
  var beginDate = getTradingPeriodBegin(tradingPeriodPrefix, tradingPeriod);
  var endDate = beginDate;

  //detect custom timeframe
  if (!beginDate) return null;

  beginDate.setMonth(beginDate.getMonth() + 1);

  return beginDate;
}


function getTradingPeriodEndV2(tradingPeriodPrefix, tradingPeriod, is_custom_timeframe) {

  if (is_custom_timeframe === true || tradingPeriodPrefix == 'PROMPT' || tradingPeriodPrefix == 'LOADED') return null;

  var beginDate = getTradingPeriodBeginV2(tradingPeriodPrefix, tradingPeriod);

  //detect custom timeframe
  if (!beginDate) return null;

  var dateObj = {};
  var pre = getTradingPeriodPreIndex(tradingPeriod);
  var month = pre.indexOf('Q') === 0 ? 3 : 1;

  beginDate.add(month, 'M');

  return beginDate;
}

module.exports = {
  monthNames: monthNames,
  getTradingPeriodBegin: getTradingPeriodBegin,
  getTradingPeriodBeginV2: getTradingPeriodBeginV2,
  getTradingPeriodEnd: getTradingPeriodEnd,
  getTradingPeriodEndV2: getTradingPeriodEndV2,
  getPeriodsForQuarter: getPeriodsForQuarter,
  getPeriodBegin: getPeriodBegin,
  getPeriodEnd: getPeriodEnd

}



//////////////////
// WEBPACK FOOTER
// ../backend/utils/tradingPeriod_utils.js
// module id = 279
// module chunks = 0